import { getSessionItem, setSessionItem, removeSessionItem } from './sessionStorage'

const SESSION_KEY = 'deeplink_redirect'
const QUERY_PARAM = 'redirect'

/** Validate redirect path is internal (starts with /, no protocol). Returns path or null. */
export function validateRedirectPath (path: string | null | undefined): string | null {
  if (!path || typeof path !== 'string') return null
  if (!path.startsWith('/')) return null
  if (path.startsWith('//')) return null
  if (path.includes('://')) return null
  return path
}

/** Read redirect from URL query param, fallback to sessionStorage. */
export function getRedirectPath (): string | null {
  const params = new URLSearchParams(window.location.search)
  const fromUrl = validateRedirectPath(params.get(QUERY_PARAM))
  if (fromUrl) return fromUrl
  return validateRedirectPath(getSessionItem(SESSION_KEY))
}

/** Save redirect to sessionStorage (for SSO/SAML flows that leave the app). */
export function saveRedirectToSession (path: string): void {
  setSessionItem(SESSION_KEY, path)
}

/** Clear stored redirect after consuming it. */
export function clearRedirect (): void {
  removeSessionItem(SESSION_KEY)
}

/** Get post-login destination: redirect path if set, else /user-dashboard. Clears storage. */
export function getPostLoginDestination (): string {
  const redirect = getRedirectPath()
  clearRedirect()
  return redirect ?? '/user-dashboard'
}

/** Append ?redirect= to a base path. Preserves extra params (e.g., sso=true). */
export function buildUrlWithRedirect (
  basePath: string,
  redirectPath: string | null,
  extraParams?: Record<string, string>
): string {
  const params = new URLSearchParams()
  if (redirectPath) params.set(QUERY_PARAM, redirectPath)
  if (extraParams) {
    Object.entries(extraParams).forEach(([k, v]) => params.set(k, v))
  }
  const qs = params.toString()
  return qs ? `${basePath}?${qs}` : basePath
}
